import { createAction } from 'redux-actions'

import * as c from './constants'

export const addNotificationBanner = createAction(
  c.ADD_NOTIFICATION,
  (id, tPath, level, { priority = 1, tFallback = '', icon = true } = {}) => ({
    id,
    icon,
    level,
    tPath,
    tFallback,
    priority,
    type: c.NOTIFICATION_TYPES.BANNER,
    bannerType: c.BANNER_TYPES.ALERT
  })
)
